import { inject, injectable } from "inversify";
import IEsiaAuthService from "./IEsiaAuthService";
import { EsiaAuthApi } from "../api/EsiaAuthApi";
import i18n from "@/i18n";
import IAlertService from "../alert/IAlertService";
import { DiTokens } from "../diTokens";
import IErrorService from "../error/IErrorService";

@injectable()
/** Сервис регистрации в ЕСИА */
export default class EsiaAuthService implements IEsiaAuthService {
  constructor(
    @inject(DiTokens.AlertService) private alertService: IAlertService,
    @inject(DiTokens.ErrorService) private errorService: IErrorService
  ) {}

  public async getEsiaRedirectLink(): Promise<string> {
    let link: string = '';

    try {
      link = await EsiaAuthApi.getRedirectLink();
    } catch (e: any) {
      await this.alertService.error(e && e.message ? e.message.toString() : 'Unknown');
    }

    return link;
  }

}
